export const AuthenticationErrorConstants = {
    'InvalidThirdPartyAddressError': 1,
    'InvalidNoEmailLogin': 2,
    'InvalidMultipleEmailLogin': 3,
    'InvalidTokenErrorMessage': 4,
    'ThirdPartyProviderNotSupported': 5,
    'BlockedUserError': 6,
    'UserHasToConfigure2Fa': 7,
    'UnknownError': 1000
};
